/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountDetailRequestSchema } from "./calculateDiscountDetailRequestSchema.ts";
import { calculateDiscountItemRequestSchema } from "./calculateDiscountItemRequestSchema.ts";

export const calculateDiscountRequestSchema = z.object({
	items: z.array(calculateDiscountItemRequestSchema).optional(),
	combos: z.array(calculateDiscountDetailRequestSchema).optional(),
	table: z.uuid().nullish(),
	order_type_id: z.uuid().nullish().describe("Внутренний ID выбранного типа заказа (Здесь/С собой)"),
	locator: z.string().max(8).nullish(),
	comment: z.string().max(50).nullish(),
	tab_name: z.string().max(50).nullish(),
	promo_code: z.string().min(1).optional(),
});
